export default function GetFormattedAttrInspector(
	defaultAttributes = {},
	tabName = 'general'
) {
	const currentTab = {};

	for ( const singleAttribute of Object.keys( defaultAttributes ) ) {
		let inspectorController =
			defaultAttributes[ singleAttribute ]?.inspectorController;
		if (
			tabName == inspectorController?.targetTab &&
			inspectorController?.targetAccordionTab
		) {
			let accordionItem = inspectorController?.targetAccordionTab;
			if ( ! currentTab.hasOwnProperty( accordionItem ) ) {
				currentTab[ accordionItem ] = [];
			}
			currentTab[ accordionItem ] = [
				...currentTab[ accordionItem ],
				{
					...inspectorController,
					// label: inspectorController?.inspectorLabel,
					// inspectorName:inspectorController?.inspectorComponent,
					defaultAttributes:
						defaultAttributes[ singleAttribute ]?.default,
					attributeKey: singleAttribute,
				},
			];
		}
	}
	return currentTab;
}
